module.exports = __webpack_public_path__ + "static/Frogsong5-da84a18dab7ba6d9a504385b934189cc.webp";